import { render, staticRenderFns } from "./new_variety_index.vue?vue&type=template&id=10890bb0&scoped=true&"
import script from "./new_variety_index.vue?vue&type=script&lang=js&"
export * from "./new_variety_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10890bb0",
  null
  
)

export default component.exports